import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CommonModal from './CommonModal';

const ActivateDeactivateModal = ({
  sentData,
  onEvent,
  onConfirm,
  apiPath,
  axios,
  columnName,
  dbAction,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [t] = useTranslation();

  useEffect(() => {
    if (sentData && onEvent) {
      setShowModal(true);
    }
  }, [sentData, onEvent]);

  const handleCloseModal = () => {
    setShowModal(false);
    onEvent({ open: false, sentData: null });
  };

  const toggleStatus = async (sentData) => {
    try {
      await axios
        .put(
          `/api/${apiPath}/${sentData.id}`,
          {
            [dbAction]: !sentData[dbAction],
          },
          { withCredentials: true }
        )
        .then((resp) => {
          setShowModal(false);
          toast.success('Status updated successfully', {
            position: 'top-center',
          });
          onConfirm();
        })
        .catch((error) => {
          console.error('Error toggling status:', error);
        });
    } catch (err) {
      console.error('Error toggling status:', err);
    }
  };

  return (
    <>
      <CommonModal
        open={showModal}
        message={`Are you sure you want to ${sentData?.[dbAction] ? 'deactivate' : 'activate'} ${sentData?.[columnName]}?`}
        buttonProps={[
          { label: 'Cancel', onClick: handleCloseModal },
          { label: 'Confirm', onClick: () => toggleStatus(sentData) },
        ]}
        hideHeader
        id="hideHeader"
      />
    </>
  );
};

export default ActivateDeactivateModal;
